<template>
  <strong v-if="bold" :class="[enumValue.class]" v-text="$t(enumValue.i18nKey)" />
  <span v-else :class="[enumValue.class]" v-text="$t(enumValue.i18nKey)" />
</template>

<script>
export default {
  props: {
    value: Number,
    enum: Object,
    bold: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    enumValue() {
      const value = Object.values(this.enum).filter(x => x.value === this.value)[0];
      if (value) return value;
      return {
        value: this.value,
        i18nKey: "common.unknownValue",
        class: "red--text"
      };
    }
  },
}
</script>